import {useState} from 'react';
import {Button, Modal} from '@ultradent/components';
import Cookie from 'js-cookie';
import {SITE_URL} from '@util/URLUtils'

const DIALOG_TITLE = upi.i18n.getTextFromKey( 'lbl-dentalProfessionalSiteUrl' );
const DIALOG_HEADLINE = upi.i18n.getTextFromKey( 'lbl-dentalProfessional' );
const DIALOG_PHRASE = upi.i18n.getTextFromKey( 'lbl-dentalProfessionalPhrase' );
const LBL_YES = upi.i18n.getTextFromKey( 'wrd-Yes', 'Yes' );
const LBL_NO = upi.i18n.getTextFromKey( 'wrd-No', 'No' );

const DentalProDialog = () => {
    const [isOpen, setIsOpen] = useState( true );

    const handleAction = actionType => e => {
        switch ( actionType ) {
            case 'yes':
                Cookie.set( 'UpiDentalProfessional', true );
                setIsOpen( false );
                break;

            case 'no':
            default:
                window.location = SITE_URL;

        }
    };

    return (
        <Modal id="isDentalProDialog"
               size="sm"
               title={DIALOG_TITLE}
               shouldCloseOnOverlayClick={false}
               isOpen={isOpen}>
                <div className="max-w-sm">
                    <section>
                        {DIALOG_HEADLINE &&
                            <h1 className="font-normal mb-2">{DIALOG_HEADLINE}</h1>
                        }
                        {DIALOG_PHRASE &&
                            <p>{DIALOG_PHRASE}</p>
                        }
                        <div className="flex justify-between mt-8 button-bar">
                            <Button data-at-label="Yes" onClick={handleAction( 'yes' )}>{LBL_YES}</Button>
                            <Button data-at-label="No" secondary onClick={handleAction( 'no' )}>{LBL_NO}</Button>
                        </div>
                    </section>
                </div>
        </Modal>
    );
}

export default DentalProDialog;
